module.exports = __webpack_public_path__ + "static/OP_Portal_Main_logo-625cc244227a8af3887eeed8e8bdbe12.svg";